import { Core } from "@faire/design-tokens";
import { FaireLogo } from "@faire/web--source/slate/icons/FaireLogo";
import { Row } from "@faire/web--source/slate/Layout";
import * as React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const ChatCsatHeader: React.FC = () => {
  return (
    <SelfServeHeader>
      <FaireLogoWrapper>
        <Link to="/">
          <FaireLogo />
        </Link>
      </FaireLogoWrapper>
    </SelfServeHeader>
  );
};

const SelfServeHeader = styled(Row).attrs({
  justify: "flex-start",
  align: "center",
})`
  height: 60px;
  padding: 32px;
  position: relative;
  border-bottom: 1px solid ${Core.border.muted};
`;

const FaireLogoWrapper = styled.div`
  position: absolute;
  margin: 0;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
